"use strict";
$.fn.isInViewport = function () {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.ForceNumericOnly = function () {
	return this.each(function () {
		$(this).keydown(function (e) {
			var isModifierkeyPressed = (e.metaKey || e.ctrlKey || e.shiftKey);
			var isCursorMoveOrDeleteAction = ([46,8,37,38,39,40].indexOf(e.keyCode) != -1);
			var isNumKeyPressed = (e.keyCode >= 48 && e.keyCode <= 58) || (e.keyCode >=96 && e.keyCode <= 105);
			var vKey = 86, cKey = 67,aKey = 65;
			switch(true){
			case isCursorMoveOrDeleteAction:
			case isModifierkeyPressed == false && isNumKeyPressed:
			case (e.metaKey || e.ctrlKey) && ([vKey,cKey,aKey].indexOf(e.keyCode) != -1):
			break;
			default:
				e.preventDefault();
			}
		});
	});
};

$.fn.center = function ($item) {
	var top = ( $(window).height() - this.height() ) / 2;
	if (top < 0){
		top = 0;
	}
	this.css("position","absolute");
	this.css("top", top  + "px");
	return this;
}

